import { call, put, takeEvery, takeLatest, select, take } from 'redux-saga/effects'
import { eventChannel } from 'redux-saga';
import { postOrderAPI, getOrders, cancelOrderAPI } from '../../../apis/orders'
import { postOrderSuccess, postOrderFail, getOrdersSuccess, cancelOrderFail, cancelOrderSuccess, updateOrderViaSocket } from './actions'
import { socket } from 'socket';
import { POST_ORDER_START, GET_ORDERS_START, CANCEL_ORDER_START, REFETCH_ORDERS, UPDATE_ORDER_VIA_SOCKET } from './actionTypes'
import { showErrorNotification, showSuccessNotification } from '../../general/notifications/actions'
import { toggleCurrentModal } from 'store/actions'

function* makeOrder({ payload }) {
  try {
    const result = yield call(postOrderAPI, payload)
    if (result.status) {
      yield put(postOrderSuccess(result))
      yield put(toggleCurrentModal('sellBuyDetail', payload))
      // yield put(showSuccessNotification(result.message));
      // yield delay(3000);
      // yield put(toggleCurrentModal(""));
    }
  } catch (error) {
    yield put(postOrderFail(error.message))
    yield put(showErrorNotification(error.message))
  }
}
function* fetchOrders({ payload }) {
  try {
    const data = yield call(getOrders, payload)
    const { result, status } = data
    if (status) {
      yield put(getOrdersSuccess(result))
    }
  } catch (error) {}
}
function* cancelOrder({ payload }) {
  try {
    const { orderId } = payload;
    const result = yield call(cancelOrderAPI, { orderId });
    if (result.status) {
      yield put(cancelOrderSuccess(orderId));
      showSuccessNotification('Order canceled successfully');
    }
  } catch (error) {

    yield put(cancelOrderFail(error.message));
    showErrorNotification(error.message);
  }
}

// Selector to get order parameters from state
const getOrderParams = (state) => state.crypto.orders.orderParams;

function createSocketChannel() {
  return eventChannel(emit => {
    const eventHandler = (data) => {
      emit(data); // Just emit without data since we don't need it
    };

    socket.on('order:update', eventHandler);
    return () => socket.off('order:update', eventHandler);
  });
}

// Worker Saga: will be fired on socket events
function* handleSocketEvent() {
  try {
    // Instead of handling the order directly, we'll just refetch the orders
    // with the current parameters
    const params = yield select(getOrderParams);
    yield call(fetchOrders, { payload: params });
  } catch (error) {
    console.error('Error handling socket event:', error);
  }
}

function* watchSocketEvents() {
  const socketChannel = yield call(createSocketChannel);
  while (true) {
    yield take(socketChannel);
    yield call(handleSocketEvent);
  }
}

function* refetchOrders() {
  try {
    const params = yield select(getOrderParams);
    yield call(fetchOrders, { payload: params });
  } catch (error) {
    console.log("Error refetching orders:", error.message);
  }
}

function* ordersSaga() {
  yield takeEvery(POST_ORDER_START, makeOrder);
  yield takeEvery(GET_ORDERS_START, fetchOrders);
  yield takeEvery(CANCEL_ORDER_START, cancelOrder);
  yield takeEvery(REFETCH_ORDERS, refetchOrders);
  yield call(watchSocketEvents);
}

export default ordersSaga
